"use client";

import React from "react";
import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IhrStressfreierUmzugInHamburg() {
  const {
    ref: headlineRef,
    isVisible: isHeadlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: trustRef,
    isVisible: isTrustVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="222469" id="smarter-finance-solutions" className="relative min-h-[90vh] md:min-h-screen flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/modern_finance_office_interior.png')] bg-cover bg-center bg-no-repeat" />
        <div className="absolute inset-0 !bg-[rgba(249,250,251,0.57)] !bg-[url(https://slafinance.com/wp-content/uploads/2026/04/modern_finance_office_interior.webp)] !bg-[url(https://slafinance.com.au/wp-content/uploads/2026/04/modern_finance_office_interior.webp)]" />
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center pt-20 pb-32">
        
        {}
        <h1 ref={headlineRef} className={`flex flex-col gap-2 md:gap-4 transition-all duration-1000 ease-out transform ${isHeadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <span className="block text-primary text-5xl sm:text-6xl md:text-7xl lg:text-[4rem] xl:text-[5rem] font-default font-bold uppercase tracking-tighter leading-[0.9]">
            Smarter Finance Solutions
          </span>
          <span className="block text-primary text-5xl sm:text-6xl md:text-7xl lg:text-[4rem] xl:text-[5rem] font-default font-bold uppercase tracking-tighter leading-[0.9]">
            Tailored To You
          </span>
        </h1>

        {}
        <div ref={trustRef} className={`mt-8 md:mt-12 flex items-center gap-3 bg-white/60 backdrop-blur-md border border-primary/10 rounded-full px-5 py-2.5 transition-all duration-1000 delay-300 ease-out transform ${isTrustVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          
          <span className="text-secondary text-sm md:text-xl font-medium tracking-wide font-default">20+ Years Collective Experience • Tailored Lending • Fast Approvals</span>
        </div>

        {}
        <div ref={ctaRef} className={`mt-10 md:mt-14 w-full md:w-auto transition-all duration-1000 delay-500 ease-out transform ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Link to="/contact/" className="block w-full md:w-auto">
            <Button size="lg" className="w-full md:w-[320px] h-16 text-lg md:text-xl font-bold uppercase tracking-wide rounded-md shadow-xl bg-accent text-accent-foreground hover:bg-accent/90 hover:scale-105 transition-all duration-300">
              Book Free Consultation
            </Button>
          </Link>
        </div>

      </div>

      {}
      
    </section>;
}